import { Box, Fade } from "@mui/material";

export default function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`pet-tabpanel-${index}`}
      aria-labelledby={`pet-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Fade in timeout={500}>
          <Box sx={{ py: { xs: 2, sm: 3 } }}>{children}</Box>
        </Fade>
      )}
    </div>
  );
}
